module.exports = __webpack_public_path__ + "static/media/b_qx_sport.ce106c9c.usdz";